import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Section } from '../../../../interfaces/questions.interface';
import { CstQuestionnaireService } from '../../../../services/cst-questionnaire.service';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
    selector: 'app-section-create',
    templateUrl: './section-create.component.html',
    styleUrls: ['./section-create.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class SectionCreateComponent implements OnInit, OnDestroy {
    public placeholder = $localize`Type section name here`;
    public descriptionPlaceholder = $localize`Description (optional)`;
    public defaultSectionName: string;
    public sectionName: string;
    public subscription: Subscription;
    public entitySubscription: Subscription;
    public sectionUUID: string | undefined;

    constructor(public cstQuestionnaireService: CstQuestionnaireService, public cdr: ChangeDetectorRef) {}

    ngOnInit() {
        this.sectionUUID = this.cstQuestionnaireService.currentSection?.id;
        /* Receive the current section each time another one is added or selected  */
        this.subscription = this.cstQuestionnaireService.getCurrentSectionObs().subscribe((section: Section) => {
            this.defaultSectionName = $localize`SECTION ` + section.number;
            this.sectionUUID = section.id;
            this.cdr.detectChanges();
        });
    }

    ngOnDestroy() {
        this.cdr.detach();
        this.subscription?.unsubscribe();
    }

    public onChangeSection($event: any) {
        const findSectionUUID = this.cstQuestionnaireService.sections.findIndex((x) => x.id === this.sectionUUID);
        this.cstQuestionnaireService.sections[findSectionUUID].section = $event;
    }

    public onChangeDescription($event: any) {
        const findSectionUUID = this.cstQuestionnaireService.sections.findIndex((x) => x.id === this.sectionUUID);
        this.cstQuestionnaireService.sections[findSectionUUID].description = $event;
    }
}
